import { StepFooter } from '@/shared/components'
import { useState } from 'react'
import { EmissionsControlAssetEditor } from './EmissionsControlAssetEditor'
import { CombustionOfFuelAssetEditor } from './CombustionOfFuelAssetEditor'
import { EmissionPointsEditorProps } from '../useAssetInstances'

export default function CementEmissionPointsEditor({
  addAssetWithId,
  removeAssetWithId,
  updateAssetWithId,
  selectedAssets,
  onPreviousClick,
  onNextClick,
  removeMultipleAssets
}: EmissionPointsEditorProps) {
  const [areEmissionsControlAssetsUsed, setAreEmissionsControlAssetsUsed] = useState(false)

  const combustionOfFuelAssets = selectedAssets.filter(
    asset => asset.emissionPoint === 'combustion_of_fuel'
  )

  const emissionsControlAssets = selectedAssets.filter(
    asset => asset.emissionPoint === 'emissions_control'
  )

  const isNextEnabled =
    ((areEmissionsControlAssetsUsed && emissionsControlAssets.length > 0) ||
      !areEmissionsControlAssetsUsed) &&
    combustionOfFuelAssets.length > 0

  return (
    <div className="space-y-4">
      <CombustionOfFuelAssetEditor
        removeMultipleAssets={removeMultipleAssets}
        selectedAssets={combustionOfFuelAssets}
        addAssetWithId={addAssetWithId}
        removeAssetWithId={removeAssetWithId}
        updateAssetWithId={updateAssetWithId}
        id="combustion_of_fuel"
      />
      <EmissionsControlAssetEditor
        areAssetsUsed={areEmissionsControlAssetsUsed}
        updateAreAssetsUsed={setAreEmissionsControlAssetsUsed}
        removeMultipleAssets={removeMultipleAssets}
        selectedAssets={emissionsControlAssets}
        addAssetWithId={addAssetWithId}
        removeAssetWithId={removeAssetWithId}
        updateAssetWithId={updateAssetWithId}
        id="emissions_control"
      />
      <StepFooter onPrevious={onPreviousClick} onNext={onNextClick} isNextEnabled={isNextEnabled} />
    </div>
  )
}
